<template>
  <div class="page">
    <h2 style="margin-bottom:15px;text-align:center;">
      {{ invoice.partnerName }}
    </h2>
    <div style="padding-left:350px;padding-right:350px;height:100px;">
      {{ invoice.partner.address }}
    </div>
    <div style="padding-left:350px;">
      <span style="width:50px;display:inline-block;text-align:left;">Tel:</span>
      <span style="width:120px;display:inline-block;text-align:left;">{{
        invoice.partner.tel
      }}</span>
    </div>
    <div style="padding-left:350px;">
      <span style="width:50px;display:inline-block;text-align:left;">Fax:</span>
      <span style="width:120px;display:inline-block;text-align:left;">{{
        invoice.partner.fax
      }}</span>
    </div>
    <div style="position:absolute; top:200px; right:40px;">
      PAGE: 1 / {{ invoice.total.value }}
    </div>
    <div style="text-align:center;margin-top:15px;">
      <h1
        style="border-bottom:1px solid #000;line-height:30px;display:inline-block;"
      >
        I N V O I C E
      </h1>
    </div>
    <div style="width:100%;text-align:right;">
      <span
        style="display:inline-block;width:120px;text-align:right;padding-right:15px;"
        >INVOICE NO:</span
      >
      <span style="display:inline-block;width:120px;text-align:left;">{{
        invoice.invoiceNo
      }}</span>
    </div>
    <div style="width:100%;text-align:right;">
      <span
        style="display:inline-block;width:120px;text-align:right;padding-right:15px;"
        >INVOICE DATE:</span
      >
      <span style="display:inline-block;width:120px;text-align:left;">{{
        invoice.creationDate
      }}</span>
    </div>
    <table class="contract-info">
      <tr>
        <td style="width:5%;">SOLD TO :</td>
        <td style="width:45%;">
          {{ invoice.companyName }}
          <br />1.TAKUMI-CHO,SAKAI-KU, SAKAI-SHI, <br />OSAKA 590-8522, JAPAN
        </td>
        <td style="width:5%;">SHIP TO :</td>
        <td style="width:45%;">
          SHARP CORPORATION
          <br />1.TAKUMI-CHO,SAKAI-KU, SAKAI-SHI, <br />OSAKA 590-8522, JAPAN
        </td>
      </tr>
      <tr>
        <td>TEL :</td>
        <td>(81)50-5433-4138</td>
        <td>TEL :</td>
        <td>(81)50-5433-4138</td>
      </tr>
      <tr>
        <td>FAX :</td>
        <td>(81)72-222-5724</td>
        <td>FAX :</td>
        <td>(81)72-222-5724</td>
      </tr>
      <tr>
        <td>ATTN :</td>
        <td></td>
        <td>ATTN :</td>
        <td></td>
      </tr>
      <tr>
        <td>FROM :</td>
        <td>{{ invoice.loadingPortName }}</td>
        <td colspan="2">SHIPPING MARK :</td>
      </tr>
      <tr>
        <td>TO :</td>
        <td>{{ invoice.dischargePortName }}</td>
        <td></td>
        <td></td>
      </tr>
      <tr>
        <td colspan="2">SHIPPING METHOD :{{ invoice.transportModeCode }}</td>
        <td></td>
        <td></td>
      </tr>
      <tr>
        <td>ETD :</td>
        <td>{{ invoice.etd }}</td>
        <td></td>
        <td></td>
      </tr>
    </table>

    <table class="contract-info" style="margin-top:15px;">
      <tr>
        <td style="width:10%;">PAYMENT TERMS :</td>
        <td style="width:90%;">{{ invoice.paymentTerm }}</td>
      </tr>
      <tr>
        <td>TRADE TERMS :</td>
        <td>{{ invoice.incotermCode }} {{ invoice.loadingPortName }}</td>
      </tr>
    </table>

    <div class="list">
      <div
        class="row"
        style="height:50px;border-top:1px solid #000;border-bottom:1px solid #000;"
      >
        <div style="left:80px;top:5px;">P/O No.</div>
        <div style="left:200px;top:5px;">SI No</div>
        <div style="left:280px;top:5px;">LOT NO.</div>
        <div style="left:450px;top:5px;">EXTERNAL NAME</div>
        <div style="left:700px;top:5px;">INTERNAL NAME</div>
        <div style="left:0px;top:25px;">DESCRIPTION</div>
        <div style="left:450px;top:25px;">QUANTITY</div>
        <div style="left:750px;top:25px;">AMOUNT(US$)</div>
      </div>
    </div>
    <div style="margin-top:30px;">(DETAILS AS PER THE ATTACHED SHEET)</div>
    <div class="row" style="height:30px;border-bottom:1px solid #000;">
      <div style="left:0px;top:5px;">TOTAL:</div>
      <div style="left:200px;top:5px;">
        {{ invoice.totalCartonQty | currency({ fractionCount: 0 }) }}CTN(S)
      </div>
      <div style="left:450px;top:5px;">
        {{ invoice.totalQty | currency({ fractionCount: 2 }) }}(PC)
      </div>
      <div style="left:750px;top:5px;">
        US${{ invoice.totalAmount | currency({ fractionCount: 2 }) }}
      </div>
    </div>
    <div style="margin-top:15px;width:100%;padding-left:400px;">
      <div>{{ invoice.partnerName }}</div>
      <div style="height:150px;border-bottom:1px solid #000;weight:100%;"></div>
      <div>BY</div>
      <div>AT</div>
      <div>ON</div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['invoice'],
}
</script>
<style scoped>
.page {
  padding: 30px 30px;
}
.contract-info {
  width: 100%;
}
.contract-info td {
  vertical-align: top;
  word-wrap: normal !important;
  padding: 5px 3px;
}
.list {
  width: 100%;
}
.row {
  width: 100%;
  position: relative;
}
.row > div {
  position: absolute;
}
</style>
